var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{ref:"masterDetail",attrs:{"hasExportCSV":false,"hasExportXLSX":false,"opts":_vm.opts,"cols":_vm.cols,"canEdit":false,"canDelete":false,"hasNewButton":false,"resourceUrl":_vm.resourceUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }